import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExamService } from 'src/app/core/exam.service';
import { ExamQuestion } from 'src/app/models/exam-question.model';
import { Exam } from 'src/app/models/exam.model';

@Component({
  selector: 'app-exam-view',
  templateUrl: './exam-view.component.html',
  styleUrls: ['./exam-view.component.scss'],
  standalone: false
})
export class ExamViewComponent {

  courseId?: number;
  examId?: number;

  isLoadingExam: boolean = true;
  isCreatingQuestions: boolean = false;

  showExamRun: boolean = false;
  showResultPage: boolean = false;

  exam?: Exam;

  constructor(
    private route: ActivatedRoute,
    private examService: ExamService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(paramMap => {
      this.courseId = Number(paramMap.get('courseId'));
      this.examId = Number(paramMap.get('examId'));
      this.loadExam();
    });
  }

  loadExam() {
    this.examService.getExam(this.examId!).subscribe((examData: any) => {
      this.exam = Exam.constructExam(examData);
      this.isLoadingExam = false;
      if (!this.exam.isFinished && (!this.exam.examQuestions || this.exam.examQuestions.length === 0)) {
        this.generateExamQuestions();
      } else if (!this.exam.isFinished) {
        this.showExamRun = true;
      } else {
        this.showResultPage = true;
      }
    });
  }

  generateExamQuestions() {
    this.isCreatingQuestions = true;

    this.examService.createExamQuestions(this.exam!.id!).subscribe((examQuestionsData: any) => {
      this.exam!.examQuestions = examQuestionsData.map((examQuestion: any) => ExamQuestion.constructExamQuestion(examQuestion));
      this.isCreatingQuestions = false;
      this.showExamRun = true;
    });
  }

  handleExamFinished(exam: Exam) {
    //save exam to updat4e isFinished
    this.showExamRun = false;
    this.showResultPage = true;
  }
}
